import React from 'react';
import { useTranslation } from 'react-i18next';
import './FeaturesSection.css';

const FeaturesSection = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: '💰',
      titleKey: 'features.payOnce.title',
      descriptionKey: 'features.payOnce.description',
      defaultTitle: 'Плати само еднаш',
      defaultDescription: 'Направете едно плаќање и обезбедете доживотен пристап без месечни плаќања и без скриени трошоци.'
    },
    {
      icon: '⏰',
      titleKey: 'features.lifetime.title',
      descriptionKey: 'features.lifetime.description',
      defaultTitle: 'Доживотен пристап и време на работа',
      defaultDescription: 'Пристапете до вашата страница за спомен во било кое време, каде било. Нашите сервери секогаш и се е достапно 24/7/365.'
    },
    {
      icon: '✏️',
      titleKey: 'features.edit.title',
      descriptionKey: 'features.edit.description',
      defaultTitle: 'Уредете во секое време',
      defaultDescription: 'Правете промени на вашата страница за спомен онолку често колку што сакате. Најавете се на нашиот сајт и направете измени, неограничено пати, без дополнителни трошоци.'
    },
    {
      icon: '⚡',
      titleKey: 'features.quality.title',
      descriptionKey: 'features.quality.description',
      defaultTitle: 'Висококвалитетен материјал Inox 304',
      defaultDescription: 'Висококвалитетен материјал Inox 304 (Stainless Steel 18/10) отпорен на сите временски услови.'
    },
    {
      icon: '🛡️',
      titleKey: 'features.respect.title',
      descriptionKey: 'features.respect.description',
      defaultTitle: 'Во сетот добивате висококвалитетен специјален лепак',
      defaultDescription: 'Во сетот добивате висококвалитетен специјален лепак наменет за рамни површини како гранит и мермер.'
    },
    {
      icon: '📧',
      titleKey: 'features.support.title',
      descriptionKey: 'features.support.description',
      defaultTitle: 'Email & Viber поддршка за креирање профил',
      defaultDescription: 'Во следниот период ќе биде достапна Email и Viber поддршка каде можете да ни испратите слики и ние ќе ви го креираме профилот за вас.'
    }
  ];

  return (
    <section className="features-section">
      <div className="features-container">
        <div className="section-header">
          <div className="section-divider">
            <div className="divider-line"></div>
            <span className="divider-text">{t('features.badge', 'Спомени')}</span>
            <div className="divider-line"></div>
          </div>
          <h2 className="section-title">
            {t('features.title', 'Нашите Карактеристики')}
          </h2>
          <p className="section-description">
            {t('features.description', 'Откријте ги сите предности што ги прави нашата платформа единствена и посебна за чување на спомените.')}
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <div className="feature-content">
                <h4 className="feature-title">
                  {t(feature.titleKey, feature.defaultTitle)}
                </h4>
                <p className="feature-description">
                  {t(feature.descriptionKey, feature.defaultDescription)}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="features-footer">
          <div className="trust-indicators">
            <div className="trust-item">
              <div className="trust-icon">🛡️</div>
              <span>{t('features.trust.secure', 'Сигурна платформа')}</span>
            </div>
            <div className="trust-item">
              <div className="trust-icon">🤝</div>
              <span>{t('features.trust.support', '24/7 поддршка')}</span>
            </div>
            <div className="trust-item">
              <div className="trust-icon">🏆</div>
              <span>{t('features.trust.quality', 'Премиум квалитет')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
